import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { FaPlusCircle, FaUsers } from 'react-icons/fa';
import * as Motion from 'motion/react';
import DashboardList, { DashboardUserListRenderComponent } from '../../components/DashboardList';
import Loader from '../../components/Loaders';
import useDialogBox from '../../hooks/useDialogBox';
import { getTemplateProtocols } from '../../api/v1/protocols';
import { getUsers, createUser } from '../../api/v1/users';
import { animationStaggeredItem } from '../../animations';
import '../../styles/screen.scss';

const { motion } = Motion;


const Users = () => {
  const formRef = useRef(null);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { resetDialogBox, setDialogBox } = useDialogBox();

  const loadUserList = async () => {
    const result = await getUsers();

    setUsers(result?.data);
  };

  const createUserSubmit = async () => {
    const { userName, protocol } = formRef.current?.getValues();

    if (!userName.length) {
      alert('Please enter a user name');
    }
    else if (protocol === '-1') {
      alert('Please select a protocol');
    }
    else {
      await createUser({
        userName,
        protocolId: protocol,
      });

      resetDialogBox();

      await loadUserList();
    }
  };

  const newUser = async () => {
    setDialogBox({
      title: 'Add User',
      content: <AddUserForm ref={formRef}/>,
      actions: [
        { title: 'Create User', type: 'primary', action: () => createUserSubmit() },
        { title: 'Cancel', type: 'cancel', action: () => resetDialogBox() }
      ]
    });
  };

  useEffect(() => {
    (async () => {
      await loadUserList();
      setIsLoading(false);
    })();
  }, []);

  return (
    <>
      <Motion.AnimatePresence>
        {isLoading && <Loader/>}
      </Motion.AnimatePresence>

      <motion.div variants={animationStaggeredItem} className="screen-header">
        <div className="screen-title-wrapper">
          <h2 className="screen-title">
            <FaUsers />
            Users
          </h2>
        </div>

        <button className="screen-header-button primary" onClick={() => newUser()}><FaPlusCircle/>New User</button>
      </motion.div>

      <DashboardList items={users} RenderComponent={DashboardUserListRenderComponent}/>
    </>
  )
};


const AddUserForm = forwardRef((props, ref) => {
  const [userName, setUserName] = useState('');
  const [protocol, setProtocol] = useState('-1');
  const [templateProtocols, setTemplateProtocols] = useState([]);

  useEffect(() => {
    (async () => {
      const result = await getTemplateProtocols();
      setTemplateProtocols(result?.data);
    })();
  }, []);

  useImperativeHandle(ref, () => ({
    getValues,
  }));

  const getValues = () => {
    return { userName, protocol };
  };

  return (
    <div className="modal-form">
      <div className="form-group">
        <label>User Name</label>
        <input placeholder="User Name" value={userName} onChange={(e) => setUserName(e.target.value)}/>
      </div>

      <div className="form-group">
        <label>Protocol</label>
        <select value={protocol} onChange={(e) => setProtocol(e.target.value)}>
          <option disabled key={-1} value={'-1'}>Select a protocol</option>
          {
            templateProtocols?.map((templateProtocol, index) => (
              <option key={index} value={templateProtocol.id}>{templateProtocol.name}</option>
            ))
          }
        </select>
      </div>
    </div>
  );
});

export default Users;
